import { render, staticRenderFns } from "./ProductSmallCard.vue?vue&type=template&id=7bcc2659&scoped=true"
import script from "./ProductSmallCard.vue?vue&type=script&lang=ts"
export * from "./ProductSmallCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductSmallCard.vue?vue&type=style&index=0&id=7bcc2659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc2659",
  null
  
)

export default component.exports